import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-services-re',
  templateUrl: './services-re.component.html',
  styleUrls:  ['../pages.scss', './services-re.component.scss']
})
export class ServicesReComponent {activeLanguage = 'german';
constructor(private ls: LanguageService) {
  ls.getLanguage().subscribe(val => this.activeLanguage = val);
}
content = {
    german: `<div class="row margin-below">
    <div class="col">
        <h1 class="header">Reliability Engineering</h1>
    </div>
  </div>
  <div class="row">
     <div class="text-content col-12">
            <p class="start-indent">
                Technologiebranchen werden von Kunden durch immer höhere Leistungsanforderungen, gesetzliche
                Vorgaben und Standards getrieben, Produkte nahe an der physikalischen Machbarkeitsgrenze anzubieten. Damit steigen auch
                die Ansprüche an Beanspruchbarkeit und Lebensdauer hoch komplexer Komponenten. TCW unterstützt Sie in der Verbesserung
                Ihrer Produktzuverlässigkeit durch:
            </p>
            <ul>
                <li>Systematische Riskoanalysen von der Vorentwicklung bis zur Serienfertigung</li>
                <li>Simulationen zur Lebensdauer kritischer Komponenten</li>
                <li>Intelligente, ausfallreduzierende Wartungskonzepte bereits im Produktdesign</li>
                <li>Erstellen und Umsetzen von Maßnahmen zur Steigerung der Produktzuverlässigkeit
                z.B. durch Reduzierung der Schwankungen in Materialien, Fertigungsprozessen und Prozessführung</li>
            </ul>
            <p><em>Fragen Sie nach konkreten Projektbeispielen und Referenzen!</em></p>
        </div>
        </div>
        <div class="row">
          <div class="col image">
            <img src="/assets/reliability.jpg">
            <p> Bildquelle: VDA QMC</p>
          </div>
        </div>`,
  english:  `
  <div class="row margin-below">
    <div class="col">
        <h1 class="header">Reliability Engineering</h1>
    </div>
  </div>
<div class="row">
   <div class="text-content col-12">
          <p class="start-indent">
            High tech business segments face increasing demands in performance, rising standards
            and legal requirements as well as product quality close to their physical and chemical limits,
            leading to higher demands of strain resistance and longevity of critical components.
            <span class="highlight">Technologie Consulting Wolke</span> is the competent partner for
            enhancing product reliability both strategically as well as on actual challenges. Services include:
          </p>
          <ul>
              <li>Systemic risk analysis of the entire product from early development through mass or serial
              production by means of FMEA or similar tools.</li>
              <li>Failure mode based lifetime simulation and assessment</li>
              <li>Create and implement strategies for most effective reliability improvement f.e. by identifying
              quality spread and variation in material, manufacturing process and validation</li>
              <li>Introduction of intelligent maintenance solutions (condition-based monitoring)
              already in he design phase of new products</li>
              <li>Design for reliability</li>
          </ul>
          <p><em>Feel free to ask for project examples and references</em></p>
      </div>
      </div>
      <div class="row">
        <div class="col image">
          <img src="/assets/reliability.jpg">
          <p>Image Source: VDA QMC</p>
        </div>`
  };
}



// WEBPACK FOOTER //
// ./src/app/components/services-re/services-re.component.ts